<!--
        课程模块
        作用：显示与加载来自场景选择的课程信息数据；
        实现：新增课程、加载课程数据、课程拖动排序、PPT导入；
        组件：element->el-tree
        参数： curForm  
        注释：WJ
-->
<template>
    <div class="lesson-box"
        :class="{
            'deep-black': true,
            'full': isFull
        }"
        @mouseover="handleMouseEnterList"
        @mouseout="handleMouseOutList"
    >
        <!--{{$store.state.menusData.lessonSelected}}-->
        <p class="add-box theme-btn hover-none"
           v-if="isAddNew">
            <el-button
                    :class="{disabled: is_global_select_menu}"
                    @click="opt('addPPT', 0, 'flash')"
                    size="mini">
                <span class="ico-box">
                    <!--<span class="ico iconfont icon-bianzu"></span>-->
                    导入pptx
                </span>
            </el-button>
        </p>
        <p class="add-box theme-btn active" v-if="isAddNew"><el-button @click="opt('add', 0, 'flash')" size="mini">
            <span class="ico-box">
                <!--<span class="ico">+</span>-->
                添加
            </span>
        </el-button></p>
        <!--{{form}}-->
        <draggable
                v-model="curForm"
                class="drop-box"
                group="people"
                :move="move"
                :options="{
                    draggable: '.move'
                }"
                @start="drag=true"
                @end="drag=false"
                @change="changeLesson"
        >
            <div
                v-for="(item,index) in curForm"
                :key="index"
                class="lesson"
                :data-key="item.unique"
                :class="{
                    active: `${item.unique}`===`${$store.state.menusData.lessonSelected}`,
                    disabled: item.disabled,
                    move: !item.disabled
                }"
                @click="handleClickSelect(item, index)"
                @mouseover.stop="handleMouseEnter(item,index)"
                @mouseout.stop="handleMouseOut"
            >
                <div class="bg">
                    <span
                        class="flag"
                        :class="enumsType[item.type]"
                    >
                        {{enumsType[item.type]}}
                    </span>
                    <span class="mengban" v-if="!mulSelect"></span>
                    <img crossOrigin="anonymous" v-if="item.thumbnail || getThumbnail(item.unique,item)" class="img" :src="getThumbnail(item.unique,item)" alt="" />
                    <!--<div class="title">{{item.config && item.config.name}}</div>-->
                    <div class="txt">
                        <p
                            v-if="mulSelect"
                            class="num select"
                            :class="{active: (mulSelect || []).includes(item.unique)}"
                        ><span class="iconfont icon-dagou"></span></p>
                        <p class="num" v-else>{{index+1}}</p>
                    </div>
                    <div v-if="$store.state.is_global_select_menu" class="checkbox-box">
                        <span v-if="`${item.unique}`===`${$store.state.global_select_unique}`" class="iconfont icon-dagou"></span>
                    </div>
                    <div class="btns-box" v-if="!mulSelect">
                        <span class="add ico-box one" @click.stop="opt('add', index)">
                            <!--添加空课件-->
                            <el-tooltip
                                class="item"
                                effect="light"
                                content="新建空白页"
                                placement="right"
                                :open-delay="$enums.openDelay.nomal"
                            >
                                <img :src="$images.menus.add" alt="add" />
                            </el-tooltip>
                        </span>
                        <span
                            class="add ico-box"
                            :class="{disabled: is_global_select_menu}"
                            @click.stop="opt('addPPT', index, '', item)"
                        >
                            <!--导入pptx-->
                            <el-tooltip
                                class="item"
                                effect="light"
                                content="导入PPT"
                                placement="right"
                                :open-delay="$enums.openDelay.nomal"
                            >
                                <img :src="$images.menus.ppt" alt="ppt" />
                            </el-tooltip>
                        </span>
                    </div>
                </div>
                <div v-if="isRemark" class="opt-box"
                >
                    <span class="remark" @click="onRemark(item,index)">查看备注</span>
                </div>
                <div v-else class="opt-box">
<!--                    <span class="edit" @click="opt('edit', item)"><img :src="$images.menus.bianji" alt=""></span>-->

<!--                    <span class="more" @click="opt('more', item)"><img :src="$images.menus.fengxiang" alt=""></span>-->
                </div>
            </div>
        </draggable>
    </div>
</template>

<script>
    import draggable from 'vuedraggable'
    import {getRandomByObj,getRandomOverByObj} from "../../../../../../utils/utils";
    import {mapState, mapActions} from 'vuex'
    import * as resultServer from '../../../../../../api/result'
    import {lessonOper} from "../../../../../../utils/lessonUtil";
    // import Operation from '../../../../../../components/Operation'

    export default {
        name: "lesson",
        components: {
            draggable,
            // Operation
        },
        props: {
            // 是否充满
            isFull: {
                type: Boolean,
                default: false
            },
            isAdd: {
                type: Boolean,
                default: false
            },
            form: Array,
            parentId: [Number, String],
            selected: [Number, String],
            mouseEnterItem: [Object, Number],
            isRemark: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            ...mapState([
                'is_global_select_menu',
                'isCocosSaving',
                'menusData',
                'menusDataIds',
                'isBuildCocos',
                'mulSelect'
            ]),
            isAddNew () {
                let state = false
                try {
                    const arr = this.curForm
                    state = (!arr || arr.length === 0) && this.$store.state.menusData.blocksForm.length
                } catch (e) {
                    console.log('等待获取当前是否新增课程状态==>')
                }
                return state
            }
        },
        watch:{
            newForm:{
                handler(vl) {
                     //if(this.isCocosSaving) return false
                     //console.warn('优化速度==>newForm')
                     this.$emit('update:form', vl)
            
                     //刷新当前菜单
                    if(vl && vl.length>1) {
                        let curMenu = this.$utils.curSelectedNode({})
                        curMenu.children = vl
                    }
                },
                deep: true,
                immediate: true
            },
            parentId(vl){this.newParentId = vl},
            newParentId(vl){this.$emit('update:parentId',vl)},
            selected(vl){this.newSelected = vl},
            newSelected(vl){this.$emit('update:selected',vl)},
            mouseEnterItem(vl){this.newMouseEnterItem = vl},
            newMouseEnterItem(vl){this.$emit('update:mouseEnterItem',vl)},
            mouseEnterLessonList(vl){this.newMouseEnterLessonList = vl},
            newMouseEnterLessonList(vl){this.$emit('update:mouseEnterLessonList',vl)}
        },
        created(){
            window.addOne = ()=>this.opt('add', this.curForm.length - 1)
            this.$nextTick(()=>{
                $eventBus.$on('onFlashLesson',this.flashLesson)
                this.flashLesson()
            })
        },
        data(){
            return {
                tempForm: this.$_.cloneDeepWith(this.newForm), // 临时表单存
                enumsType: {
                    html: 'ppt',
                    game: '游戏'
                },
                scrollFn: null, // 滚动事件
                isShow: false,
                newMouseEnterItem: this.mouseEnterItem, // 鼠标移到的数据元素
                newMouseEnterLessonList: this.mouseEnterLessonList, // 鼠标移到的数据元素LessonList
                newForm: this.form,
                newParentId: this.parentId, // 板块id
                newSelected: this.selected,
                curForm: [], // 当前配置
                lessonFn: null // 切换菜单事件
            }
        },
        methods: {
            ...mapActions(['setGlobalSselectUnique']),
            flashLesson(isNoContent, callback){
                // 3.刷新课件列表
                this.$store.state.operationSteps.push(this.$enums.operationStep.changeLesson)
                //console.log("3.刷新课件列表");
                let arr = []
                try {
                    //console.log('12==>', this.menusDataIds)
                    arr = this.$_.cloneDeepWith(this.menusDataIds[this.menusData.blocksSelected].children)
                } catch (e) {
                    console.log('获取当前课件失败==>', e)
                }
                this.curForm = arr

                $eventBus.$emit('onCurForm', arr || [])

                // 刷新内容区
                if(!isNoContent)this.$emit('flashContent')

                callback && callback()
            },
            getThumbnail(unique){//,item){
                const node = this.menusDataIds[unique]
                return node.thumbnail || this.getGameImg(unique) || this.getThemeImg(unique);
            },
            getGameImg(unique){//,item){
                let url = ''
                const node = this.menusDataIds[unique]
                if(node?.config?.cocosGameBackgroundImage){
                    url = node?.config?.cocosGameBackgroundImage
                }
                return url
            },
            getThemeImg(unique){
              let url = ''
              const node = this.menusDataIds[unique]
              if(node?.theme?.background?.url){
                  url = node?.theme?.background?.url
              }
              return url
            },
            in_array(search,array){
                for(var i in array){
                    if(array[i]==search){
                        return true;
                    }
                }
                return false;
            },
            getStatus(item){
              let state = false
              if (['game', 'tools'].includes(item.type)) {
                  const type = this.$store.state.curClassType
                  switch (type) {
                    case 'online':
                        state = !item.config.is_online
                        if(`${item.config.is_online}` === `undefined`) state = false
                        break
                    case 'offline':
                        state = !item.config.is_offline
                        if(`${item.config.is_offline}` === `undefined`) state = false
                        break
                    case 'double_teacher':
                        state = !item.config.is_double_teacher
                        if(`${item.config.is_double_teacher}` === `undefined`) state = false
                        break
                  }
              }
              return state
            },
            move(evt, originalEvent){
                this.tempForm = this.$_.cloneDeepWith(this.curForm)
                console.log('移动中==>', evt, originalEvent)
                //console.log('移动中==>1', this.$_.cloneDeepWith(this.curForm))
                // 保存中 不可移动
                if(this.$store.state.saving) return false
            },
            changeLesson(data) {
                //console.log('move==>', this.$_.cloneDeepWith(this.curForm),data)
                let value = getRandomByObj(data.moved.element)
                value = this.menusDataIds[value.unique]
                //console.log('retro lessonSelected16')
                this.$store.state.menusData.lessonSelected = value.unique
                this.$store.state.menusData.lessonSelectedConfig = value
                this.$store.state.menusData.willGo = value.unique
                this.$store.state.menusData.willGoConfig = {type: value.type}

                // TODO 交换课件
                const operation = [{node: 'children', fromUnique:this.tempForm[data.moved.oldIndex].unique, toUnique:this.tempForm[data.moved.newIndex].unique, operation: 'transfer'}]
                $eventBus.$emit('__save__',true,null, operation)
                //console.log('操作==>交换课件', operation)

                // 向cocos重新发配置
                //console.log('优化速度changeLesson==>GetLessonConfig')
                //console.log('retro=>向cocos发配置8')
                this.$store.dispatch('setIsBuilding', true)
                this.$toCocosMessage({type: 'GetLessonConfig', value: getRandomByObj(value)})

                this.menusDataIds[this.menusData.blocksSelected].children = this.curForm

                const node = this.$utils.curSelectedNode({unique: this.menusData.blocksSelected})
                node.children = this.curForm
            },
            onRemark(item, index){
                this.$emit('onRemark', item , index)
            },
            deleteLesson(data, parentIndex){
                //console.log('lesson==>', data, parentIndex)
                if(data){
                    this.opt('del', data, parentIndex)
                }
            },
            moveLesson(data){
                lessonOper(data,"move");
                this.$message.success('课件剪切成功')
            },
            copyLesson(data){
                lessonOper(data,"copy");
                this.$message.success('课件复制成功')
            },
            async pasteLesson(){
                if (this.isBuildCocos || this.$store.state.saving) {
                    this.$message.success('课件还在构建中，请稍后在粘贴；')
                    return false;
                }
                
                //先获取本地操作数据
                const key=localStorage.getItem("lessonOperKey");
                let str=localStorage.getItem(key);
                let time=localStorage.getItem("lessonOperTime");
                if(time>0)time=new Date().getTime()-time;

                let data=JSON.parse(str);//转换为JSON
                //如果本地操作数据不存在，则获取网络数据；
                if(!str && str !== 0 && typeof str !== "boolean"){
                    let res = await resultServer.cacheGet();
                    console.log("res",res)
                    if(res.data && ("data" in res.data))data=JSON.parse(res.data.data);
                }
                
                let menuOperData=data;

                if(!menuOperData || !("type" in menuOperData) ){
                    this.$message.success('请先复制或剪切课件；')
                    return false;
                }
                
                console.log("this.$store.state.menusData",this.$store.state.menusData);
                if (!this.$store.state.menusData.blocksForm || (this.$store.state.menusData.blocksForm && this.$store.state.menusData.blocksForm.length <= 0)) {
                    this.$message.success('请先新增导航后操作；')
                    return false;
                }

                let blockUnique=this.$store.state.menusData.blocksSelected;
                if(menuOperData.type=="copy" || menuOperData.id!=this.$store.state.initConfig.id){//当前为复制类型
                    menuOperData.lesson.forEach(v=>{
                        this.sigleCopy({lesson:v,blockUnique});
                    })
                }else{//否则为剪切
                    let deleteNode = {}
                    menuOperData.lesson.forEach(v=>{
                        deleteNode = this.sigleMove({lesson:v,dir:menuOperData.dir,blockUnique});
                    })
                    const children = this.menusDataIds[(deleteNode && deleteNode.parentNode.unique) || '']?.children
                    $eventBus.$emit('onCurForm', children || [])
                    $eventBus.$emit('onFlashLesson')
                    resultServer.cacheClear();
                }

                this.$message.success('课件粘贴成功')
                this.selectLesson(this.$store.state.menusData.lessonSelected,blockUnique);
                this.flashLesson()//刷新菜单
                return ;
            },
            // 复制一个课件
            sigleCopy({lesson, blockUnique}){
                if(!lesson || !("unique" in lesson))return 0;
                const node = this.menusDataIds[blockUnique]
                const nodeMenu = this.$utils.curSelectedNode({unique: blockUnique})
                let newObj = lesson;
                newObj = getRandomOverByObj(newObj)

                // TODO 复制课件
                const operation = [{node: 'children',toUnique: this.$store.state.menusData.lessonSelected, leafUnique: node.unique,data:newObj,operation: 'add'}]
                $eventBus.$emit('__save__',true,null, operation)
                
                if (!node.children || (node.children && node.children.length <= 0)) {
                    node.children = [newObj]
                } else {
                    let index=0;
                    let thisunique=this.$store.state.menusData.lessonSelected;
                    node.children.map((v, i)=>{
                        if(`${v.unique}` === `${thisunique}`)index = i
                    })
                    node.children.splice(index+1, 0, newObj)
                }
                nodeMenu.children = this.$_.cloneDeepWith(node.children)


                // 如果菜单中存在重复unique,重新计算A
                //node.children = this.$utils.calcNavIsUnique({data:node.children})
                this.menusDataIds[blockUnique].children = node.children
                this.menusDataIds[`${newObj.unique}`] = newObj
                
                this.$store.state.menusData.lessonSelected=newObj.unique;
                this.$store.state.menusData.blocksSelected=blockUnique;
                return newObj;
            },
            // 移动一个课件
            sigleMove({lesson,dir,blockUnique}){
                if(!lesson || !("unique" in lesson))return 0;
                let unique=lesson.unique;

                const deleteNode = this.$utils.getObjByCurLesson({
                    unique,
                    type: 'delete'
                })
                const deleteNode1 =  this.menusDataIds[dir]
                if(deleteNode1 && deleteNode1.children){
                    let index = -1
                    deleteNode1.children.map((v, i)=>{
                        if(`${v.unique}` === `${unique}`){
                            index = i
                        }
                    })
                    if(index>-1) deleteNode1.children.splice(index, 1)
                }

                // 2.移动到其他板块的下面
                const node = this.menusDataIds[blockUnique]
                const nodeMenu = this.$utils.curSelectedNode({unique: blockUnique})
                console.log("this.$store.state.menusData",this.$store.state.menusData,lesson,unique);
                let newObj = lesson;

                // TODO 移动课件 先删后加
                const operation = [
                    {node: 'children',toUnique: newObj.unique,operation: 'delete'},
                    {node: 'children',toUnique: this.$store.state.menusData.lessonSelected, leafUnique: node.unique,data:newObj,operation: 'add'}
                ]
                $eventBus.$emit('__save__',true,null, operation)
                console.log('操作==>移动课件', operation,nodeMenu)

                if (!node.children || (node.children && node.children.length <= 0)) {
                    node.children = [newObj]
                    nodeMenu.children = this.$_.cloneDeepWith(node.children)
                } else {
                    let index=0;
                    let thisunique=this.$store.state.menusData.lessonSelected;
                    node.children.map((v, i)=>{
                        if(`${v.unique}` === `${thisunique}`)index = i
                    })
                    //node.children.push(newObj)
                    node.children.splice(index+1, 0, newObj)
                    nodeMenu.children = this.$_.cloneDeepWith(node.children)
                }
                this.$store.state.menusData.lessonSelected=newObj.unique;
                this.$store.state.menusData.blocksSelected=blockUnique;
                console.log("当前节点课件数据：",this.menusDataIds[blockUnique].children);
                console.log("课件粘贴成功：",this.menusDataIds,this.$store.state.menusDataIds,this.menusData,this.$store.state.menusData);
                
                const children = this.menusDataIds[blockUnique || '']?.children
                $eventBus.$emit('onCurForm', children || [])
                return deleteNode
            },
            handleClickSelect(item, index){
                if(this.mulSelect){
                    const index = this.mulSelect.indexOf(item.unique)
                    if(index>-1){
                        this.mulSelect.splice(index, 1)
                    } else{
                        this.mulSelect.push(item.unique)
                    }
                    return false
                }

                this.$store.state.editGameConfig = null
                //console.log('优化速度==>开始切换课件')
                // 如果正在构建 禁止切换
                if(this.isBuildCocos){
                    return false
                }
                // 当前只为选中菜单
                if(this.$store.state.is_global_select_menu){
                    this.setGlobalSselectUnique(item.unique)
                    return false
                }
                if(item.disabled){
                    return false
                }
                clearTimeout(this.lessonFn)
                if (!this.$store.state.saving) {
                    //console.log('优化速度==>1', new Date().getTime())
                    this.$store.state.menusData.willGo = item.unique
                    this.$store.state.menusData.willGoConfig = {type: item.type}
                    this.opt('onSelect', {parentId: this.$store.state.menusData.blocksSelected, index})
                }
            },
            selectLesson(key,dir){
                this.$store.state.editGameConfig = null
                let item=this.menusDataIds[key];
                console.log('开始切换课件',this.menusDataIds,key,dir,item)
                
                if(this.isBuildCocos)return false// 如果正在构建 禁止切换
                // 当前只为选中菜单
                if(this.$store.state.is_global_select_menu){
                    this.setGlobalSselectUnique(item.unique)
                    return false
                }
                if(item.disabled)return false
                
                let index="";
                let children=this.menusDataIds[dir].children

                children.map((v,i)=>{
                    if(v.unique==key)index=i;
                });

                clearTimeout(this.lessonFn)
                if (!this.$store.state.saving) {
                    this.$store.state.menusData.willGo = key
                    this.$store.state.menusData.willGoConfig = {type: item.type}
                    this.opt('onSelect', {parentId: this.$store.state.menusData.blocksSelected, index})
                }
            },
            opt(type, data, index, item){
                // 选择菜单状态时，不允许插入ppt
                if(type === 'addPPT' && this.is_global_select_menu){
                    return
                }
                if(this.$store.state.saving){
                    return false
                }
                //console.log('优化速度==>2', type, data, index, item, new Date().getTime())
                if(['add', 'onSelect'].includes(type)) {
                    this.$store.dispatch('setSaving', true)
                    // this.$store.dispatch('setIsBuilding', true)
                }
                this.$emit(type, data, index, item)

                // 滚轮滚动一个页面高度
                if(['add'].includes(type)) {
                    this.goScroll()
                }
            },
            // 获取当前滚动条滚动位置
            getScrollPosition(){
                let div = document.querySelector('.lesson-box')
                return div && div.scrollTop || 0
            },
            // 设置滚动条位置
            setScrollPosition({position}){
                let div = document.querySelector('.lesson-box')
                div.scrollTop = position
            },
            goScroll(){
                let div = document.querySelector('.lesson-box')
                // console.log('滚动高度==>', div.scrollTop)
                // this.goAnimate({div, maxScrollTop: div.scrollTop + 145})
                let fn = setTimeout(()=>{
                    div.scrollTop = div.scrollTop + 145
                    clearTimeout(fn)
                }, 200)
            },
            goAnimate({maxScrollTop}){
                try {
                    let div = document.querySelector('.lesson-box')
                    const self = this
                    self.scrollFn = requestAnimationFrame(function() {
                        // 页面滚动的距离
                        let scrollTop = div.scrollTop;
                        div.scrollTop = scrollTop + 10;
                        console.log('ddddddd==>', div.scrollTop, scrollTop, maxScrollTop)
                        if(div.scrollTop <= maxScrollTop){
                            requestAnimationFrame(self.goAnimate.bind(this,{maxScrollTop}))
                        }else {
                            cancelAnimationFrame(self.scrollFn)
                        }
                    })
                }catch (e) {
                    console.log('滚动失败==>', e)
                }
            },
            handleMouseEnter(item,index){
                this.newMouseEnterItem = {...item,index}
                // console.log('鼠标遇上==>', this.mouseEnterItem )
            },
            handleMouseOut(){
                this.newMouseEnterItem = null
                // console.log('鼠标离开==>', this.mouseEnterItem )
            },
            handleMouseEnterList(){
                this.newMouseEnterLessonList = true
            },
            handleMouseOutList(){
                this.newMouseEnterLessonList = null
            }
        },
        destroyed() {
            $eventBus.$off('onFlashLesson')
        }
    }
</script>

<style>
.lesson-box .add-box .el-button--mini{
    width:192px;
    height:34px;
    background:rgba(255, 120, 56,0.1);
    border-radius:4px;
    border:1px solid rgba(255, 120, 56,0.3);
    font-size:14px;
    font-weight:500;
    color:rgba(255, 120, 56,1);
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-top: 12px;
}
.lesson-box .add-box .el-button--mini .ico-box {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}
.lesson-box .add-box .el-button--mini .ico {
    margin-right: 6px;
    font-size: 20px;
}
</style>
<style lang="scss" scoped>
@-webkit-keyframes bounceIn{0%,40%,60%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}
0%{-webkit-transform:scale3d(.3,.3,.3);opacity:0;transform:scale3d(.3,.3,.3)}
40%{-webkit-transform:scale3d(1.1,1.1,1.1);transform:scale3d(1.1,1.1,1.1)}
60%{-webkit-transform:scale3d(.9,.9,.9);transform:scale3d(.9,.9,.9)}
to{-webkit-transform:scaleX(1);opacity:1;transform:scaleX(1)}}
@keyframes bounceIn{0%,20%,40%,60%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}
0%{-webkit-transform:scale3d(.3,.3,.3);opacity:0;transform:scale3d(.3,.3,.3)}
40%{-webkit-transform:scale3d(1.1,1.1,1.1);transform:scale3d(1.1,1.1,1.1)}
60%{-webkit-transform:scale3d(.9,.9,.9);transform:scale3d(.9,.9,.9)}
to{-webkit-transform:scaleX(1);opacity:1;transform:scaleX(1)}
}
.lesson-box{
    width: 230px;
    /*box-shadow:0px 0px 5px 0px rgba(0, 0, 0, 0.06);*/
    max-height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    margin-right: 3px;

    .add-box{
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 0px 14px;
        width: calc(100% - 26px);
        background-color: initial !important;
        border: none !important;

        .disabled{
            cursor: not-allowed;
        }
        .icon-bianzu{
            font-size: 14px;
        }
    }

    .lesson{
        width: 192px;
        height: 131px;
        padding: 10px 20px;
        padding-left: 16px;
        position: relative;
        transform: scale(1);
        transition: all .2s linear;
        -webkit-backface-visibility: hidden;
        user-select: none;
        display: flex;
        flex-shrink: 0;

        &.disabled{
            filter: grayscale(100%);
            opacity: .8;
            transform: scale(.9) !important;
        }

        &:nth-child(1) {
            padding-top: 20px;
        }

        &:hover, &.active{
            transform: scale(1);
            -webkit-backface-visibility: hidden;

            .bg{
                border: 3px solid #e7622e;
            }
        }

        .bg{
            width: 100%;
            height: 100%;
            background-color: #f1f1f1;
            border-radius: 5px;
            position: relative;
            overflow: hidden;
            border: 3px solid white;
            transition: border .2s linear;
            cursor: pointer;

            &:hover .btns-box{
                opacity: 1;
            }

            .mengban{
                background: linear-gradient(0deg, rgba(0, 0, 0, 0) 0%, #000000 100%);
                opacity: 0.15;
                position: absolute;
                width: 100%;
                height: 101px;
                z-index: 10;
            }

            .checkbox-box{
                position: absolute;
                top: 5px;
                left: 5px;
                width: 16px;
                height: 16px;
                background: #FFFFFF;
                border: 1px solid #e7622e;
                border-radius: 4px;
                z-index: 11;
                display: flex;
                justify-content: center;
                align-items: center;

                .icon-dagou{
                    font-weight: bold;
                    font-size: 16px;
                    color: #e7622e;
                }
            }

            .title{
                position: absolute;
                left: 0px;
                top: 0px;
                z-index: 10;
                display: flex;
                flex-direction: row;
                justify-content: center;
                flex: 1;
                width: 80%;
                color: #fff;
                text-shadow: 0px 2px 17px rgba(0, 0, 0, 0.3);
                margin-top: 5px;
                font-size: 12px;
                padding: 0px 10%;
                max-height: 96px;
                overflow: hidden;
                text-overflow: ellipsis;
            }

            .ico-box{
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                font-size: 14px;
                color: white;
                user-select: none;
                outline: none;

                &.disabled{
                    cursor: not-allowed;
                }
            }
            .ico {
                margin-right: 6px;
                font-size: 20px;
                position: relative;
                top: -2px;
                user-select: none;
            }

            .btns-box{
                position: absolute;
                bottom: 0px;
                width: 100%;
                height: 30px;
                background: #606266;
                border-radius:0px 0px 4px 4px;
                cursor: pointer;
                display: flex;
                flex-direction: row;
                align-items: center;
                opacity: 0;
                transition: all .2s linear;

                .add{
                    display: flex;
                    flex: 1;
                    position: relative;
                    transition: color .2s linear;

                    &:hover{
                        color: #e7622e;
                    }

                    &.one:after{
                        position: absolute;
                        top: 4px;
                        right: -1px;
                        content: '';
                        width: 1px;
                        height: 14px;
                        background-color: white;
                    }
                }
            }

            .img{
                width: 100%;
                height: 101px;
                object-fit: contain;
                position: relative;
            }
            .txt{
                position: absolute;
                left: 0px;
                top: 0px;
                width: 100%;
                height: 100%;
                /*background-color: rgba(0,0,0,.2);*/

                .num{
                    text-align: center;
                    width:18px;
                    height:18px;
                    line-height: 18px;
                    background:rgba(255,255,255,.8);
                    border-radius:4px;
                    font-size:12px;
                    font-weight:400;
                    color:rgba(48,49,51,1);
                    margin: 6px;
                    user-select: none;

                    &.select{
                        width: 14px;
                        height: 14px;
                        border-radius: 2px;
                        border: 1px solid #BDBEC7;
                        background:rgba(255,255,255,0) !important;
                        .icon-dagou{
                            display: none;
                        }

                        &.active{
                            background-color: #FF7838 !important;
                            border-color: #FF7838 !important;

                            .icon-dagou{
                                display: inline-block;
                                position: relative;
                                left: -1px;
                            }
                        }
                    }
                }
            }
        }
        .opt-box{
            display: flex;
            flex-direction: row;
            justify-content: space-around;
            align-items: center;
            width: calc(100% - 21px);
            position: absolute;
            left: 0px;
            bottom: -12px;
            padding: 0px 10.5px;

            .remark{
                padding: 2px 10px;
                font-size: 14px;
                position: absolute;
                bottom: 27px;
                left: 58px;
                background: gold;
                border-radius: 11px;
                cursor: pointer;
            }
            .edit{
                position: relative;
                left: 12px;
                top: -20px;
                cursor: pointer;

                &>img{
                    width: 22px;
                    height: 22px;
                }
            }
            .add{
                position: relative;
                top: -4px;
                cursor: pointer;

                &>img{
                    width: 26px;
                    height: 25px;
                }
            }
            .more{
                position: relative;
                top: -20px;
                right: 5px;
                cursor: pointer;

                &>img{
                    width: 29px;
                    height: 14px;
                }
            }
        }
    }

    &.deep-black{
        background-color: #26282E;
        width: 126px;

        &.full{
            width: 230px;

            .drop-box {
                height: calc(100vh - 156px);
                .lesson {
                    width: 160px;
                    height: 86px;
                    &:hover{
                        width: 160px;
                        height: 86px;
                    }

                    &.active {
                        width: 190px;
                        height: 106px;
                    }
                    /*&.active + .lesson {
                        width: 174px;
                        height: 96px;
                    }*/
                }
            }
        }

        .drop-box {
            display: flex;
            flex-direction: column;
            align-items: center;
            padding-bottom: 14px;
            overflow-y: auto;
            overflow-x: hidden;
            height: calc(100vh - 124px);
            transition: all 0.3s ease-out 0s;
            -webkit-transition: all 0.3s ease-out 0s;

            .lesson {
                /*width: 90px;*/
                /*height: 50px;*/
                margin-top:14px;
                width: 98px;
                height: 54px;
                padding: 0px 14px 0px;
                &.sortable-ghost .bg{
                    border: 2px dotted #000;
                    animation: bounceIn 0.6s linear 0s 1 normal;
                    -webkit-animation: bounceIn 0.6s linear 0s 1 normal;
                }

                &:hover, &.active {
                    width: 98px;
                    height: 54px;

                    .bg {
                        border-color: #FF7838;
                    }
                }
                &.active{
                    width: 110px;
                    height: 62px;
                    padding: 0px 8px 0px 8px;
                    .bg {
                        animation: bounceIn 0.6s linear 0s 1 normal;
                        -webkit-animation: bounceIn 0.6s linear 0s 1 normal;
                    }
                }

                .bg {
                    border: 1px solid #26292e;

                    .flag{
                        position: absolute;
                        top: -5px;
                        right: -5px;
                        z-index: 15;
                        font-size: 12px;
                        color: white;
                        background-color: #FF7838;
                        border-top-right-radius: 5px;
                        border-bottom-left-radius: 5px;
                        padding: 2px 4px;
                        transform: scale(.7);
                    }
                    .mengban, .img {
                        height: 100%;
                        object-fit: cover;
                    }

                    .txt {
                        .num {
                            color: white;
                            width: 14px;
                            height: 14px;
                            line-height: 14px;
                            background: rgba(0, 0, 0, 0.3);
                            border-radius: 2px;
                        }
                    }
                    .btns-box {
                        padding: 5px;
                        width: calc(100% - 10px);
                        height: initial;
                        background-color: initial;
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;
                        z-index: 12;

                        .add {
                            flex: initial;
                            &.one:after {
                                display: none;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
